export default "__VITE_ASSET__CVh8uwce__"